import React from 'react';
import CustomMenuButton from './Wrapper';

const MenuButton = ({ ...rest }) => (
  <CustomMenuButton {...rest}></CustomMenuButton>
);

MenuButton.propTypes = {};
export default MenuButton;
